import { Suspense } from "react";
import { ThemeProvider } from "@mui/material";

import theme from "@/theme/default.ts";
import AppRoutes from "@/AppRoutes.tsx";
import { AppProvider } from "@/context/app";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ModuleFallBack from "@/components/ModuleFallBack";
import InitialDataLoader from "@/components/InitialDataLoader";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./index.css"
import "@fontsource/poppins/100.css";
import "@fontsource/poppins/200.css";
import "@fontsource/poppins/300.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/800.css";
import "@fontsource/poppins/900.css";

import "@/integration/helpia-people/src/App.css";
import { Toaster } from "sonner";
import IdleTimer from "./components/IdleTimer";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // networkMode: "online"
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <Toaster richColors />
        <Suspense fallback={<ModuleFallBack />}>
          <AppProvider>
            <InitialDataLoader />
            <IdleTimer>
              <AppRoutes />
            </IdleTimer>
            <ToastContainer theme={"colored"} />
          </AppProvider>
        </Suspense>
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
